/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScannerDiscoverEndpointRequest
 */
export interface ScannerDiscoverEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof ScannerDiscoverEndpointRequest
     */
    path: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScannerDiscoverEndpointRequest
     */
    recursive?: boolean | null;
}

export function ScannerDiscoverEndpointRequestFromJSON(json: any): ScannerDiscoverEndpointRequest {
    return ScannerDiscoverEndpointRequestFromJSONTyped(json, false);
}

export function ScannerDiscoverEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScannerDiscoverEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
        'recursive': !exists(json, 'recursive') ? undefined : json['recursive'],
    };
}

export function ScannerDiscoverEndpointRequestToJSON(value?: ScannerDiscoverEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'recursive': value.recursive,
    };
}


